import { TRASH_FILLED_24 } from "@sznds/icons";
import { IEvent } from "~/activerequest/interfaces";
import AlternativePOIDialog from "~/ui/alternativepoidialog";
import createSDSIcon from "~/ui/icon";
import { createRatingCard } from "~/ui/ratingcard";
import { node } from "~/util/dom";
import { updateReviewState } from "~/util/providers/review";
import { IEventPoiagg } from "~/interfaces";
import { isTwin, getReviewConf } from "~/util/review";
import { _ } from "~/i18n";
import ReviewPopup, { IReviewPopupOptions } from "~/review/popupwc";

interface ISuggestedItemOptions {
	event: IEvent;
	onReject: () => void;
	onFinished: IReviewPopupOptions["onClose"];
	onWrongPOI: () => void;
}

function getSignal(data) {
	const poiData = data?.data?.poi?.poiagg || { typeId: 0, id: 0 };

	return `${poiData.typeId}_${poiData.id}`;
}

export default class SuggestedItem {
	_container: HTMLLIElement;

	_closeButton: HTMLButtonElement;

	_onReject: () => void;

	_onFinished: IReviewPopupOptions["onClose"];

	_onWrongPOI: () => void;

	_isEventCorrected: boolean;

	constructor({
		event,
		onReject,
		onFinished,
		onWrongPOI,
	}: ISuggestedItemOptions) {
		const data = {
			...event.data.poi.poiagg,
			review: event.review_data || event.review,
			myReview: null,
		};

		this._container = node("li", { className: "suggesteditem" });
		this._onReject = onReject;
		this._onFinished = onFinished;
		this._onWrongPOI = onWrongPOI;
		this._isEventCorrected = false;

		// obsah karty je vlastne jen hodnotici karta z aktivnich zadosti
		this._container.appendChild(createRatingCard({
			// FIXME: narovnat typy
			// @ts-ignore
			poi: data,
			onStructuredRating: structuredData => {
				// eslint-disable-next-line no-new
				new ReviewPopup({
					data: getReviewConf(data),
					textReview: false,
					forceRating: structuredData.rating,
					onClose: closeData => {
						this._onFinished && this._onFinished(closeData);
					},
					logObj: this._getFirmLogObj(event),
					activeRequest: true,
				});
			},
			onStarsClick: putReviewData => {
				updateReviewState(event.id, "rated");

				if (putReviewData.review) {
					// FIXME: narovnat typy
					// @ts-ignore
					data.review = putReviewData.review;
				}

				data.myReview = putReviewData.myReview;

				// eslint-disable-next-line no-new
				new ReviewPopup({
					data: getReviewConf(data),
					textReview: !!data.myReview,
					forceRating: putReviewData.myReview.rating,
					onClose: closeData => {
						this._onFinished && this._onFinished(closeData);
					},
					logObj: this._getFirmLogObj(event),
					activeRequest: true,
				});
			},
			onPOIClick: () => {
				Mapy.getComponent("logger").log("click", {
					signal: getSignal(event),
					text: "suggestionGoToDetail",
					section: "suggestionDashboard",
				});

				Mapy.getComponent("detail").setState({
					source: event.data.poi.source,
					id: event.data.poi.id,
					backTitle: _("mymap.switcher.reviews"),
				}).then(() => {
					Mapy.getComponent("history").save();
				}, () => {});
			},
			onPOIChoice: () => {
				this._sendAnalytics("click", event, {
					text: "Byli jste jinde",
				});

				const dialog = new AlternativePOIDialog({
					event,
					onClose: () => {
						this._sendAnalytics("click", event, {
							text: "backFromCorrection",
						});
						dialog.close();
						dialog.destroy();
					},
					onPOISelect: (poi: IEventPoiagg) => {
						this._sendAnalytics("click", event, {
							text: "suggestionCorrect",
						});

						this._isEventCorrected = true;

						dialog.close();
						dialog.destroy();

						// eslint-disable-next-line no-new
						new ReviewPopup({
							data: getReviewConf(poi),
							textReview: false,
							onClose: closeData => {
								this._onFinished && this._onFinished(closeData);
							},
							logObj: this._getFirmLogObj(event),
						});
					},
					onInvalidRequest: () => {
						this._sendAnalytics("click", event, {
							text: "Není to žádné z těchto míst",
						});
						this._sendAnalytics("suggestion_flow_close", event, {
							count: 0,
							origin: "notAnyPlace",
							typePoi: "suggested",
						});
						dialog.close();
						dialog.destroy();
						this._onWrongPOI && this._onWrongPOI();
					},
				});

				dialog.open();
			},
			logObj: this._getFirmLogObj(event),
			activeRequest: true,
		}));

		// zaviraci tlacitko
		this._closeButton = node("button", { type: "button", className: "suggesteditem__closeButton" });
		this._closeButton.setAttribute("data-log-ignore", "true");
		this._closeButton.appendChild(createSDSIcon({
			symbol: TRASH_FILLED_24,
		}));
		this._closeButton.addEventListener("pointerdown", this);
		this._container.appendChild(this._closeButton);
	}

	get node() {
		return this._container;
	}

	get isEventCorrected() {
		return this._isEventCorrected;
	}

	destroy() {
		this._closeButton.removeEventListener("click", this);
	}

	handleEvent() {
		this._onReject && this._onReject();
	}

	_getFirmLogObj(event) {
		return {
			// eslint-disable-next-line camelcase
			rating_layout: 0,
			source: "recenze-suggestions",
			signal: getSignal(event),
			typePoi: this.isEventCorrected ? "corrected" : "suggested",
			section: "reviews",
			position: "top",
			sourcePoi: event?.data?.poi?.poiagg?.source,
			typeid: event?.data?.poi?.poiagg?.typeId,
			firmTwin: isTwin(event?.data?.poi?.poiagg) ? 1 : 0,
		};
	}

	_sendAnalytics(action, data, opts) {
		Mapy.getComponent("logger").log(action, {
			signal: getSignal(data),
			typePoi: this.isEventCorrected ? "corrected" : "suggested",
			section: "suggestionDashboard",
			...opts,
		});
	}
}
